module.exports = __webpack_public_path__ + "assets/3e3fa231b982febd6667e96ab1b66a62.mp3";